export default __webpack_public_path__ + "static/media/COO.21a030b2.png";